(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banners"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Safari iOS fix para texto que no aparece debajo de imágenes lazy
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    const items = document.querySelectorAll('.hdt-banner__item-below');
    if (items.length) {
      const refresh = () => {
        items.forEach(el => {
          el.style.display = 'block';
          el.style.transform = 'translateZ(0)';
          el.style.willChange = 'transform';
        });
        window.dispatchEvent(new Event('resize'));
      };
      window.addEventListener('load', refresh);
      window.addEventListener('scroll', refresh);
      setTimeout(refresh, 100);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-reviews-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    new Swiper('.bp-reviews-swiper', {
      slidesPerView: 3,
      spaceBetween: 25,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
